import React from 'react';
import ReactDOM from 'react-dom';
import template from "lodash/template";
import general from "general";
import constants from "general/constants";
import "general/pages/profile/common";
import { getPatientGroup } from "general/utils";
import { RMCPPractitionerAlert } from "general/components/alert/RMCPPractitionerAlert";

let activeClass = constants.activeClass;
$(document).ready(function () {
    var practitionerData = $("#practitioner-data"),
        practitionerId = practitionerData.data("practitioner-id"),
        contactNumberTemplate = template($('#contact-number-template').html()),
        contactNumberConversionImageTemplate = '<img height="1" width="1" style="display: inline; border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/932685311/?value=1.00&amp;currency_code=ZAR&amp;label=bcIwCL6Rg1cQ_8vevAM&amp;guid=ON&amp;script=0"/>',
        profileTab = $(".js-profile-tab"),
        profileTabContent = $(".js-profile-tab-content"),
        contactNumberContainer = $(".profile__copy-item--contact-number");

    // profile tabs
    function selectTab(selectedTab) {
        var tab = $(selectedTab),
            index = tab.index();

        tab.addClass(activeClass).siblings().removeClass(activeClass);
        profileTabContent.eq(index).addClass(activeClass).siblings().removeClass(activeClass);
    }

    profileTab.click(function(){
        selectTab($(this));
    });

    if (window.location.hash.substr(1) == "reviews") {
        if ($(window).width() < 768) {
            $('.profile__tab-content-item--reviews').attr('id', 'reviews');
        } else {
            $('.profile__tab-listing .profile__tab-item--reviews').attr('id', 'reviews');
            selectTab(".js-profile-tab.profile__tab-item--reviews");
        }
    }

    // Stars
    $(".gp__rating-container--profile span").click(function (e) {
        $(".profile__tab-container")
            .find(".profile__tab-item.is-active").add(".profile__tab-content-item.is-active")
                .removeClass(activeClass)
                .end().end()
            .find(".profile__tab-item--reviews").add(".profile__tab-content-item--reviews")
                .addClass(activeClass)
                .end();
       location.href="#profile__tab-container";
    });

    // Phone Number
    contactNumberContainer.one("click", function () {
        contactNumberContainer
            .removeClass("unclicked")
            .find("span").remove().end()
            .append(contactNumberTemplate())
            .append(contactNumberConversionImageTemplate);
        general.registerUserActivity("Phone Number", "Clicked", "Practitioner ID", practitionerId);
    });

    // Calendar
    $("#booking-calendar").booking({
        id: "practitioner-calendar",
        practitionerIds: [practitionerData.data("practitioner-id")],
        workplaceId: practitionerData.data("workplace-id"),
        templates: {
            form: template($("#appointment-form-template").html())
        }
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    })

    const alertEl = document.querySelector("#react-profile-alert");
    const pgName = getPatientGroup();
    if (alertEl) {
        ReactDOM.render(
            <React.StrictMode>
                <RMCPPractitionerAlert
                    pgName={pgName}
                    practitionerId={practitionerId}
                />
            </React.StrictMode>,
            alertEl
        )
    }

});
